"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.closeModalAction = exports.openErrorModalAction = exports.openModalAction = exports.MODAL_CLOSE_ACTION = exports.MODAL_OPEN_ACTION = exports.MODAL_INITIALIZE_INSTANCE_STATE = void 0;
var modals_1 = __importDefault(require("@dtna/dvs-core-dcp-client-constants/lib/constants/modals"));
var modal_model_1 = require("../models/modal.model");
exports.MODAL_INITIALIZE_INSTANCE_STATE = 'MODAL_INITIALIZE_INSTANCE_STATE';
exports.MODAL_OPEN_ACTION = 'MODAL_OPEN_ACTION';
exports.MODAL_CLOSE_ACTION = 'MODAL_CLOSE_ACTION';
var openModalAction = function (id) { return function (dispatch) { return dispatch({
    type: exports.MODAL_OPEN_ACTION,
    payload: id,
}); }; };
exports.openModalAction = openModalAction;
var openErrorModalAction = function () { return function (dispatch) { return dispatch({
    type: exports.MODAL_OPEN_ACTION,
    payload: modals_1.default.ERROR,
}); }; };
exports.openErrorModalAction = openErrorModalAction;
var closeModalAction = function () { return function (dispatch) { return dispatch({
    type: exports.MODAL_CLOSE_ACTION,
}); }; };
exports.closeModalAction = closeModalAction;
// eslint-disable-next-line default-param-last
function modalReducer(state, action) {
    if (state === void 0) { state = (0, modal_model_1.modalStateFactory)(); }
    switch (action.type) {
        case exports.MODAL_OPEN_ACTION:
            return __assign(__assign({}, state), { activeModal: action.payload });
        case exports.MODAL_CLOSE_ACTION:
            return __assign(__assign({}, state), { activeModal: modals_1.default.NONE });
        default: return state;
    }
}
exports.default = modalReducer;
